import {
  NO_RETRY_READ,
  type RequestPolicy,
} from '@/core/lib/fetcher/request-policy'
import { createSessionSwrScope, type SwrKey } from '@/core/lib/swr/swr.key'
import type { Bootstrap } from '@/features/veluvit/types/api.types'

export const APP_READ_POLICY: RequestPolicy = Object.freeze({
  ...NO_RETRY_READ,
  id: 'app-read-v1',
  maxResponseBytes: 4_194_304,
})

export const APP_BOOTSTRAP_PATH = '/bootstrap/?initialize=false'

export function appSwrKey(epoch: string, path = APP_BOOTSTRAP_PATH): SwrKey {
  return [
    path,
    { scope: createSessionSwrScope(epoch), requestPolicy: APP_READ_POLICY },
  ]
}

export function sessionAccessKey(data: Bootstrap | null): string {
  return [
    data?.user?.settings?.showAdult,
    data?.config?.adult?.eligible,
    data?.user?.role === 'admin',
    data?.user?.creator,
  ]
    .map((value) => (value ? '1' : '0'))
    .join('')
}
